/** The signed-in instructor's own referral-partner standing, for the Refer & earn page. */
export interface MyPartnerStatus {
  isPartner: boolean;
  termsAccepted: boolean;
  code: string | null;
  acceptanceToken: string | null;
  referralCount: number;
  convertedCount: number;
  unpaidAmountMinorUnits: number;
  paidAmountMinorUnits: number;
  bountyAmountMinorUnits: number;
  bountyCurrency: string;
  payoutThresholdMinorUnits: number;
  trialExtensionDays: number;
}

/** The partner's share link — what they put in posts and messages. */
export const myShareLink = (status: MyPartnerStatus): string | null =>
  status.code ? `${window.location.origin}/?ref=${status.code}` : null;

/** The tokenized public page where the partner accepts the terms. */
export const myTermsLink = (status: MyPartnerStatus): string | null =>
  status.acceptanceToken ? `/partner/terms/${status.acceptanceToken}` : null;
